const RefreshInstallment = ({ item, onBack }) => {
    const formatDate = (date) =>
        date ? new Date(date).toLocaleDateString("en-GB") : "N/A";

    const formatDateTime = (ts) =>
        ts ? new Date(ts).toLocaleString("en-GB") : "N/A";

    const formatText = (text) =>
        text ? text.replaceAll("_", " ").toLowerCase().replace(/\b\w/g, c => c.toUpperCase()) : "N/A";

    const payee = item?.payees?.[0];

    return (
        <div className="max-w-5xl mx-auto bg-white border rounded-lg shadow p-6">
            <button
                onClick={onBack}
                className="mb-4 px-4 py-2 text-white text-sm bg-blue-500 rounded hover:bg-blue-600"
            >
                ← Back to Installments
            </button>
            <h3 className="text-2xl font-semibold mb-6 text-center">
                Installment Refreshed
            </h3>

            <div className="grid md:grid-cols-2 gap-6 text-sm">
               
                <div className="space-y-4">
                    <Detail label="Installment ID" value={item?.id} />
                    <Detail label="Reference ID" value={item?.reference_id} />
                    <Detail label="Mandate ID" value={item?.mandate_id} />
                    <Detail label="Description" value={item?.client_meta?.description} />

                    <Detail label="Due Date" value={formatDate(item?.due_date)} />
                    <Detail label="Scheduled Date" value={formatDate(item?.schedule_date)} />
                    <Detail label="Time Zone" value={item?.time_zone} />

                    <Detail label="Created At" value={formatDateTime(item?.created_at)} />
                    <Detail label="Updated At" value={formatDateTime(item?.updated_at)} />
                </div>

                <div className="space-y-4">
                    <div className="border rounded p-3">
                        <p className="font-semibold mb-2">Payer Details</p>

                        <Detail label="Name" value={item?.payer?.account?.name} />
                        <Detail label="Mobile" value={item?.payer?.account?.mobile_number} />
                        <Detail label="Amount" value={`₹ ${item?.payer?.amount?.value}`} />
                        <Detail label="Mode" value={formatText(item?.payer?.mode)} />
                        <Detail label="Tag" value={formatText(item?.payer?.tag)} />
                        <Detail label="VPA" value={item?.payer?.instrument?.vpa} />
                    </div>

                    {payee && (
                        <div className="border rounded p-3">
                            <p className="font-semibold mb-2">Payee Details</p>

                            <Detail label="Tag" value={formatText(payee?.tag)} />
                            <Detail label="Amount" value={`₹ ${payee?.amount?.value}`} />
                            <Detail label="Mobile" value={payee?.account?.mobile_number} />
                        </div>
                    )}

                    <div className="flex justify-between border-t pt-3">
                        <span className="text-gray-500">Current Status</span>
                        <span className="font-semibold">{item?.state}</span>
                    </div>
                </div>
            </div>   
        </div>
    );
};

const Detail = ({ label, value }) => (
    <div className="flex justify-between gap-4 border-b pb-1">
        <span className="text-gray-500">{label}</span>
        <span className="font-medium text-right break-all">{value || "N/A"}</span>
    </div>
);

export default RefreshInstallment;
